/* src/modules/discounts/cards/DiscountsCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 90,
    overflow: 'auto',
  },
});



// WEBPACK FOOTER //
// ./src/modules/discounts/cards/DiscountsCard/styles.js